// Inputs ---> Lightness Params (steps, stepping method, min, max) AND the current step
// Outputs --> A single lightness value

import {roundToDecimal} from './round-to.js';

export function getSwatchLightness(steps, min, max, method, id) {
    if (method === 'Linear') {
        return linear(steps, min, max, id);
    } else if (method === 'Ease in/out') {
        return easeInEaseOut(steps, min, max, id);
    }
}

function linear(steps, min, max, id) {
    const spread = max - min;
    let stepSize = spread / (steps - 1)
    let lightness;

    if (steps === 1) {
        // if there is only one step, get the midpoint
        lightness = (spread / 2) + min;
    } else {
        lightness = roundToDecimal((id * stepSize) + min, 2);
    }
    return lightness;
}

function easeInEaseOut(steps, min, max, id) {
    const spread = max - min;
    const midStep = (steps - 1) / 2;
    const linearStepSize = spread / (steps - 1)
    let easedStepSize = linearStepSize;
    let lightness = linear(steps, min, max, id);

    let shiftFactor, easedLightness;
    if (steps < 4) {
        easedLightness = lightness; // don't ease the lightness, just use linear algo
    } else {
        if (id === midStep || id === 0 || id === (steps - 1)) {
            easedLightness = lightness; // first, middle and last steps are same as linear
        } else if (id < midStep) {
            easedLightness = min;
            for (let i = 0; i < id; i++) {
                shiftFactor = ((lightness - min) / (spread / 2)); // how close to the pole is the linear step from the midpoint (as a percentage)
                easedStepSize = linearStepSize * shiftFactor;
                easedLightness += easedStepSize;
            }
        } else if (id > midStep) {
            easedLightness = max;
            // now rolling in reverse for this
            for (let i = 0; i < (steps - id - 1); i++) {
                shiftFactor = ((max - lightness) / (spread / 2)); // how close to the pole is the linear step from the midpoint (as a percentage)
                easedStepSize = linearStepSize * shiftFactor;
                easedLightness -= easedStepSize;
            }
        }
    }
    let rounded = roundToDecimal(easedLightness, 2);
    return rounded;
}